import React, {FC, useCallback, useReducer} from "react";
import styled from "@emotion/styled";
import {Trans, useTranslation} from "react-i18next";
import {SecretPageKey} from "data/constants/secretPage";
import {Exist} from "views/components/Exist";
import {eq} from "lodash";
import logoEN from "assets/img/logo-landing-en.png";
import logoFR from "assets/img/logo-landing-fr.png";

const Wrapper = styled.div`
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 40px;
	gap: 40px;
	background: ${({theme}) => theme.background.tertiary};
`;

const Logo = styled.img`
	max-width: 263px;
	width: 100%;

	@media (min-width: 769px) {
		width: 70%;
		max-width: 590px;
	}
`;

const Title = styled.div`
	font-weight: 700;
	font-family: "Hind", sans-serif;
	line-height: 120%;
	color: #ffffff;
`;

export const SecretPage: FC = () => {
	const {i18n} = useTranslation();
	const [clickCounter, counterIncrementHandler] = useReducer((state) => ++state, 1);

	const clickHandler = useCallback(() => {
		counterIncrementHandler();

		if (clickCounter >= 10) {
			localStorage.setItem(SecretPageKey, "true");
			window.location.reload();
		}
	}, [clickCounter]);

	return (
		<Wrapper>
			<Exist when={eq(i18n.language, "en")}>
				<Logo src={logoEN} alt="CFL PickEm" />
			</Exist>
			<Exist when={eq(i18n.language, "fr")}>
				<Logo src={logoFR} alt="LCF Jeu Des Predictions" />
			</Exist>
			<Title>
				<Trans
					i18nKey="secret.title"
					components={{text: <span onClick={clickHandler} role="presentation" />}}
				/>
			</Title>
		</Wrapper>
	);
};
